<template>
  <div>
    <section
      v-if="detail.traininginfo1_title && detail.traininginfo1_body"
      id="traininginfo1"
      class="hospitalsDetailSection"
    >
      <div class="hospitalsDetailSection_ttl">
        <HeadingLv2 :text="detail.traininginfo1_title" />
      </div>
      <div class="hospitalsDetailSection_cnt">
        <div class="hospitalsDetailSection_block">
          <p
            class="hospitalsdetailSection_text"
            v-html="detail.traininginfo1_body"
          ></p>
        </div>
      </div>
    </section>

    <section
      id="schedule"
      class="hospitalsDetailSection"
      v-if="
        !!detail.hospital_training_program &&
          detail.hospital_training_program.length > 0
      "
    >
      <div class="hospitalsDetailSection_ttl">
        <HeadingLv2 text="臨床研修プログラム" />
      </div>
      <section
        class="hospitalsDetailSection_cnt"
        v-for="(program, index) in detail.hospital_training_program"
        :key="index"
      >
        <HeadingLv3
          :text="program.title"
          class="hospitalsDetailSection_blockTtl"
          v-if="program.title"
        />

        <p
          class="hospitalsdetailSection_text"
          v-html="program.note"
          v-if="program.note"
        />

        <div class="hospitalsDetailSection_block">
          <HospitalsDetailProgramTable
            :data="[
              JSON.parse(program['1st_year_sched']),
              JSON.parse(program['2nd_year_sched'])
            ]"
          />
        </div>
      </section>
    </section>

    <section
      id="recruit"
      class="hospitalsDetailSection"
      v-if="isNotEmptyData(recruitData) || isNotEmptyData(visitData)"
    >
      <div class="hospitalsDetailSection_ttl">
        <HeadingLv2 text="採用試験・病院見学" />
      </div>

      <div class="hospitalsDetailSection_cnt">
        <section v-if="isNotEmptyData(recruitData)">
          <HeadingLv3 text="採用試験" class="hospitalsDetailSection_blockTtl" />
          <TableSimple :rows="recruitData" />
        </section>

        <section v-if="isNotEmptyData(visitData)">
          <HeadingLv3 text="病院見学" class="hospitalsDetailSection_blockTtl" />
          <TableSimple :rows="visitData" />
        </section>
      </div>
    </section>

    <div class="hospitalsDetailSection hiddenPc">
      <div class="hospitalsDetailSection_cnt">
        <div class="hospitalsDetailSection_block">
          <HospitalContactBtn
            :id="detail.hospital_id"
            :paid-flg="detail.paid_flg === 1"
            @click-favorite="() => $emit('click-favorite')"
          />
        </div>
      </div>
    </div>

    <section
      id="salary"
      class="hospitalsDetailSection"
      v-if="isNotEmptyData(salaryData)"
    >
      <div class="hospitalsDetailSection_ttl">
        <HeadingLv2 text="給与・勤務体系・福利厚生" />
      </div>
      <div class="hospitalsDetailSection_cnt">
        <TableSimple :rows="salaryData" />
      </div>
    </section>

    <section
      v-if="detail.traininginfo2_title && detail.traininginfo2_body"
      id="traininginfo2"
      class="hospitalsDetailSection"
    >
      <div class="hospitalsDetailSection_ttl">
        <HeadingLv2 :text="detail.traininginfo2_title" />
      </div>
      <div class="hospitalsDetailSection_cnt">
        <div class="hospitalsDetailSection_block">
          <p
            class="hospitalsdetailSection_text"
            v-html="detail.traininginfo2_body"
          ></p>
        </div>
      </div>
    </section>

    <section
      id="contact"
      class="hospitalsDetailSection"
      v-if="isNotEmptyData(contactData)"
    >
      <div class="hospitalsDetailSection_ttl">
        <HeadingLv2 text="お問い合わせ・お申し込み" />
      </div>
      <div class="hospitalsDetailSection_cnt">
        <div class="hospitalsDetailSection_block">
          <TableSimple :rows="contactData" />
        </div>
      </div>
    </section>

    <section
      v-if="detail.traininginfo3_title && detail.traininginfo3_body"
      id="traininginfo3"
      class="hospitalsDetailSection"
    >
      <div class="hospitalsDetailSection_ttl">
        <HeadingLv2 :text="detail.traininginfo3_title" />
      </div>
      <div class="hospitalsDetailSection_cnt">
        <div class="hospitalsDetailSection_block">
          <p
            class="hospitalsdetailSection_text"
            v-html="detail.traininginfo3_body"
          ></p>
        </div>
      </div>
    </section>

    <section
      v-if="detail.traininginfo4_title && detail.traininginfo4_body"
      id="traininginfo4"
      class="hospitalsDetailSection"
    >
      <div class="hospitalsDetailSection_ttl">
        <HeadingLv2 :text="detail.traininginfo4_title" />
      </div>
      <div class="hospitalsDetailSection_cnt">
        <div class="hospitalsDetailSection_block">
          <p
            class="hospitalsdetailSection_text"
            v-html="detail.traininginfo4_body"
          ></p>
        </div>
      </div>
    </section>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'

import TableSimple from '@/components/elements/TableSimple.vue'
import HeadingLv2 from '@/components/elements/HeadingLv2.vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import { numberFormatAddComma } from '@/utils/commonMethods'
import HospitalContactBtn from '@/components/block/HospitalContactBtn.vue'
import HospitalsDetailProgramTable from '@/components/block/HospitalsDetailProgramTable.vue'
export default defineComponent({
  components: {
    TableSimple,
    HeadingLv2,
    HeadingLv3,
    HospitalContactBtn,
    HospitalsDetailProgramTable
  },

  props: {
    detail: {
      type: Object,
      default: () => ({})
    }
  },

  setup(props: any) {
    const recruitData = computed(() => {
      return [
        { th: '応募方法', td: props.detail.qualification || '' },
        { th: '試験日', td: props.detail.test_day || '' },
        { th: '選考方法', td: props.detail.selection_process || '' },
        { th: '応募書類', td: props.detail.application_documents || '' },
        {
          th: '募集定員',
          td: props.detail.positions_num
            ? numberFormatAddComma(props.detail.positions_num) + '名'
            : ''
        },
        {
          th: '前年度採用者数',
          td: props.detail.employees_num
            ? numberFormatAddComma(props.detail.employees_num) + '人'
            : ''
        },
        {
          th: '前年度応募者数',
          td: props.detail.applicants_num
            ? numberFormatAddComma(props.detail.applicants_num) + '人'
            : ''
        },
        {
          th: '研修医の主な出身大学',
          td: props.detail.j_graduating_school
            ? props.detail.j_graduating_school.join('、')
            : ''
        }
      ]
    })
    const visitData = computed(() => {
      return [
        { th: '病院見学実施日', td: props.detail.hospital_tour_date || '' },
        { th: '病院見学補助', td: props.detail.hospital_tour_subsidy || '' }
      ]
    })

    const showYr1SalaryDetail =
      !!props.detail.yr1_monthly_salary ||
      !!props.detail.yr1_annual_salary ||
      !!props.detail.yr1_base_salary ||
      !!props.detail.yr1_fixed_overtime ||
      !!props.detail.yr1_desc
    const yr1SalaryDetail = `<span class="bold">1年次(月給／年収)</span>${
      props.detail.yr1_monthly_salary
        ? `・月給：${props.detail.yr1_monthly_salary}`
        : ''
    }${
      props.detail.yr1_annual_salary
        ? `／年収：${props.detail.yr1_annual_salary}`
        : ''
    }${
      props.detail.yr1_base_salary
        ? `<br/>・基本給：${props.detail.yr1_base_salary}`
        : ''
    }${
      props.detail.yr1_fixed_overtime === 1 ||
      props.detail.yr1_fixed_overtime === 0
        ? `<br/>・固定残業代：${
            props.detail.yr1_fixed_overtime === 1 ? '有' : '無'
          }`
        : ''
    }${
      props.detail.yr1_desc
        ? `<span class="sub">${props.detail.yr1_desc}</span>`
        : ''
    }`

    const showYr2SalaryDetail =
      !!props.detail.yr1_monthly_salary ||
      !!props.detail.yr1_annual_salary ||
      !!props.detail.yr1_base_salary ||
      !!props.detail.yr1_fixed_overtime ||
      !!props.detail.yr1_desc

    const yr2SalaryDetail = `<span class="bold">2年次(月給／年収)</span>${
      props.detail.yr2_monthly_salary
        ? `・月給：${props.detail.yr2_monthly_salary}`
        : ''
    }${
      props.detail.yr2_annual_salary
        ? `／年収：${props.detail.yr2_annual_salary}`
        : ''
    }${
      props.detail.yr2_base_salary
        ? `<br/>・基本給：${props.detail.yr2_base_salary}`
        : ''
    }${
      props.detail.yr2_fixed_overtime === 1 ||
      props.detail.yr2_fixed_overtime === 0
        ? `<br/>・固定残業代：${
            props.detail.yr2_fixed_overtime === 1 ? '有' : '無'
          }`
        : ''
    }${
      props.detail.yr2_desc
        ? `<span class="sub">${props.detail.yr2_desc}</span>`
        : ''
    }`
    const salaryDetail = `${showYr1SalaryDetail ? yr1SalaryDetail : ''}${
      showYr2SalaryDetail ? yr2SalaryDetail : ''
    }${
      props.detail.hospital_junior_recruits_salary
        ? ` <span class="bold">備考</span>${props.detail.hospital_junior_recruits_salary}`
        : ''
    }`
    const allowanceDetail = `${
      props.detail.allowance
        ? `<span class="bold">一律手当</span>${props.detail.allowance}`
        : ''
    }${
      props.detail.other_allowance
        ? `<span class="bold">その他手当</span>${props.detail.other_allowance}`
        : ''
    }`
    const salaryData = computed(() => {
      return [
        {
          th: '勤務地',
          td: props.detail.prefectures + props.detail.hospital_address || ''
        },
        {
          th: '研修期間・身分',
          td: props.detail.training_period || ''
        },
        {
          th: '試用期間',
          td:
            (props.detail.trial === 1
              ? '有'
              : props.detail.trial === 0
              ? '無'
              : '') || '',
          sub: props.detail.trial_desc || ''
        },
        {
          th: '給与',
          td: salaryDetail || ''
        },
        {
          th: '手当',
          td: allowanceDetail || ''
        },
        {
          th: '賞与',
          td: props.detail.bonus || '',
          sub: props.detail.bonus_desc || ''
        },
        {
          th: '休暇・休日',
          td: props.detail.holiday_note || ''
        },
        {
          th: '勤務時間・休憩時間',
          td: props.detail.working_hours || ''
        },
        {
          th: '時間外勤務',
          td: props.detail.overtime_hours_mavg || '',
          sub: props.detail.overtime_desc || ''
        },
        {
          th: '当直回数・当直時の勤務体制',
          td: props.detail.shifts_system || ''
        },
        {
          th: '加入保険',
          td: props.detail.social_insurance || ''
        },
        {
          th: '医師賠償責任保険',
          td: props.detail.medical_liability_insurance || ''
        },
        {
          th: '住宅補助・寮',
          td: props.detail.house || '',
          sub: props.detail.house_desc || ''
        },
        {
          th: '福利厚生・健康診断',
          td: props.detail.welfare || ''
        },
        {
          th: '受動喫煙の取組詳細',
          td: props.detail.smoking_policy || ''
        },
        {
          th: '学会補助',
          td: props.detail.conference_subsidy || ''
        }
      ]
    })

    const contactData = computed(() => {
      return [
        { th: '問い合わせ担当者', td: props.detail.recruiter },
        { th: 'TEL', td: props.detail.tel },
        { th: 'FAX', td: props.detail.fax },
        { th: 'メール', td: props.detail.email, mail: true }
      ]
    })
    const isNotEmptyData = (data: any) => {
      let res = false
      data.forEach((el: any) => {
        if (el.td) res = true
      })
      return res
    }

    return {
      recruitData,
      salaryData,
      visitData,
      contactData,
      isNotEmptyData
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.hospitalsDetailSection_blockTtl {
}
</style>
